<template>
  <form class="simple_form form-inline form-inline--search" v-on:submit.prevent>
    <div class="form-group adaptive-placeholder string optional">
      <div class="form-control-wrapper">
        <input
          class="form-control adaptive-placeholder string optional"
          type="text"
          id="query_fulltext"
          v-model="fulltext"
          v-on:keyup="clearField"
        >
        <label
          class="control-label string optional"
          tag="div"
          for="query_fulltext"
        >
          {{ $t('search_by_certification') }}
        </label>
      </div>
    </div>
    <div class="form-inline__label">{{ $t('or') }}</div>
    <div class="form-group adaptive-placeholder string optional query_field select">
      <div class="form-control-wrapper">
        <select
          class="select required custom-select fill"
          id="query_field"
          v-model="field"
          @change="clearFulltext"
        >
          <option value="null">{{ $t('all') }}</option>
          <option
            v-for="field in fields"
            :key="field.id"
            :value="field.id"
          >
            {{ field.title }}<!--  ({{ field.entries_count }}) -->
          </option>
        </select>
        <label
          class="control-label"
          for="query_field"
        >
          {{ $t('search_by_field') }}
        </label>
        <svg class="icon icon-arrow-down-simple">
          <use xlink:href="#icons-arrow-down-simple" />
        </svg>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  mapActions as mapSearchActions,
  mapGetters as mapSearchGetters,
  getterTypes,
  actionTypes,
} from 'vuex-search';

export default {
  name: 'CertificationsFilter',
  props: ['query', 'defaultField'],
  data() {
    return {
      field: this.defaultField,
      fulltext: this.query,
    }
  },
  computed: {
    ...mapGetters({
      fields: 'fields'
    })
  },
  methods: {
    ...mapSearchActions('certifications', {
      searchCertification: actionTypes.search,
    }),
    clearField() {
      this.field = null;
    },
    clearFulltext() {
      this.fulltext = '';
    },
  },
  watch: {
    field(value) {
      this.$store.dispatch('filterByField', value);
    },
    fulltext(value) {
      this.searchCertification(value);
      this.$store.dispatch('filterByFulltext', value);
    }
  },
};
</script>

<i18n>
{
  "cs": {
    "or": "nebo",
    "all": "Všechny",
    "search_by_certification": "Hledejte podle certifikace",
    "search_by_field": "Hledejte podle oboru certifikace"
  },
  "en": {
    "or": "or",
    "all": "All",
    "search_by_certification": "Search by certification",
    "search_by_field": "Search by field"
  },
  "it": {
    "or": "o",
    "all": "Tutte",
    "search_by_certification": "Ricerca per certificazioni",
    "search_by_field": "Cerca per campo"
  }
}
</i18n>
